import { render, staticRenderFns } from "./cardChatGrupo.vue?vue&type=template&id=4de31618"
import script from "./cardChatGrupo.vue?vue&type=script&lang=js"
export * from "./cardChatGrupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports